<template>
  <div style=" background-color: #E5E8EE; height: 2px;"></div>
</template>

<script>
export default {
  name: 'LayoutBlockSeparator',
}
</script>
